import { UniversalCouponInput } from '@fff-web/fff-payments';
import { useReactivatePlanDataContext } from '../../utils/ContextProviders/ReactivatePlanDataContext';

const MIN_DISCOUNT_THRESHOLD = 1;

const ReactivateCouponInputContainer = () => {
  const {
    discount,
    couponData,
    error,
    handleCallCouponApi,
    loading: couponLoading,
    coupon,
    handleOnChange: handleOnChangeCoupon,
  } = useReactivatePlanDataContext();

  // We don't want to show the discount if it's less than $1 USD
  const discountFormatted =
    discount >= MIN_DISCOUNT_THRESHOLD ? `-$${discount.toFixed(2)}` : undefined;

  return (
    <UniversalCouponInput
      couponData={couponData}
      error={error}
      handleCallCouponApi={handleCallCouponApi}
      loading={couponLoading}
      coupon={coupon}
      handleOnChange={handleOnChangeCoupon}
      variant="secondary"
      label="Promo Code/Gift Card"
      placeholder="Promo Code/Gift Card"
      discount={discountFormatted}
    />
  );
};

export default ReactivateCouponInputContainer;
